import React, { useCallback, useEffect, useState } from 'react';
import Fireworks from 'react-canvas-confetti/dist/presets/fireworks';
import { TConductorInstance } from 'react-canvas-confetti/dist/types';

import { alpha } from '@mui/material';
import theme from '@src/theme';

const Confetti = () => {
  const [initConductor, setInitConductor] = useState<TConductorInstance>();

  const onRun = useCallback(() => {
    initConductor?.run({ speed: 1 });
  }, [initConductor]);

  const onInit = ({ conductor }: { conductor: TConductorInstance }) => {
    setInitConductor(conductor);
  };

  useEffect(() => {
    onRun();
  }, [onRun]);
  return (
    <Fireworks
      onInit={onInit}
      style={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1299,
        ...(theme.secondary.s1 && {
          background: alpha(theme.secondary.s1, 0.7),
        }),
        width: '100%',
        height: '100%',
      }}
    />
  );
};

export default Confetti;
